export const languageConstants = {
  CONSTANTS: { en: 'English' },
  DEFAULT_LANGUAGE: 'en',
};
